/*=============================================== Form ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Mixins from "./Mixins";
import Flexbox from "./Flexbox";
import Button from "./Button";
/*==================== Component ====================*/
var Form = function (_a) {
    var children = _a.children, buttonPrimary = _a.buttonPrimary, _b = _a.buttonSecondary, buttonSecondary = _b === void 0 ? undefined : _b, _c = _a.buttonSecondaryText, buttonSecondaryText = _c === void 0 ? buttonSecondary === "cancel" ? "Cancel" : buttonSecondary === "reset" ? "Reset" : "" : _c, buttonSecondaryTo = _a.buttonSecondaryTo, onClickSecondary = _a.onClickSecondary, iconLeftPrimary = _a.iconLeftPrimary, iconRightPrimary = _a.iconRightPrimary, iconLeftSecondary = _a.iconLeftSecondary, iconRightSecondary = _a.iconRightSecondary, props = __rest(_a, ["children", "buttonPrimary", "buttonSecondary", "buttonSecondaryText", "buttonSecondaryTo", "onClickSecondary", "iconLeftPrimary", "iconRightPrimary", "iconLeftSecondary", "iconRightSecondary"]);
    return (React.createElement(Container, __assign({}, props),
        children,
        (buttonPrimary || buttonSecondary) && (React.createElement(Flexbox, { gap: "xs", align: "center" },
            buttonPrimary && (React.createElement(Button, { type: "submit", fajnyIconLeft: iconLeftPrimary, fajnyIconRight: iconRightPrimary }, buttonPrimary)),
            buttonSecondary && (React.createElement(Button, { type: buttonSecondary === "reset" ? "reset" : buttonSecondaryTo ? undefined : "button", to: buttonSecondaryTo && buttonSecondaryTo, buttonStyle: "text", color: "primary", onClick: onClickSecondary, fajnyIconLeft: iconLeftSecondary, fajnyIconRight: iconRightSecondary }, buttonSecondaryText))))));
};
export default Form;
/*==================== Styles ====================*/
var Container = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n"], ["\n    ", ";\n"])), Mixins.Grid({
    $gap: "m",
}));
var templateObject_1;
